module.exports = __webpack_public_path__ + "img/pic1.3279e046.png";